import { gql } from "@apollo/client"

/**
 * Service mutations corresponding to REST /services endpoints.
 */

export const CREATE_SERVICE = gql`
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      id
      service_name
      service_price
      service_duration
      target_audience
      service_type
      treatment_type
      resource
      online_booking
      featured
      status
      service_category {
        id
        category_name
      }
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_SERVICE = gql`
  mutation UpdateService($id: ID!, $input: UpdateServiceInput!) {
    updateService(id: $id, input: $input) {
      id
      service_name
      service_price
      service_duration
      target_audience
      service_type
      treatment_type
      resource
      online_booking
      featured
      status
      service_category {
        id
        category_name
      }
      updatedAt
    }
  }
`

export const DELETE_SERVICE = gql`
  mutation DeleteService($id: ID!) {
    deleteService(id: $id) {
      id
    }
  }
`

export const RESTORE_SERVICE = gql`
  mutation RestoreService($id: ID!) {
    restoreService(id: $id) {
      id
      status
    }
  }
`


